"use client";
import * as React from "react";
const SvgNotificationsOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 13 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M6.5 16c.9 0 1.63-.74 1.63-1.64H4.87c0 .9.74 1.64 1.63 1.64m4.88-4.92v-4.1c0-2.53-1.33-4.63-3.66-5.2v-.55C7.72.55 7.17 0 6.5 0S5.28.55 5.28 1.23v.56c-2.32.56-3.66 2.66-3.66 5.18v4.1L0 12.73v.82h13v-.82zm-1.63.82h-6.5V6.97c0-2.03 1.23-3.69 3.25-3.69s3.25 1.66 3.25 3.7z" }));
export {
  SvgNotificationsOutlined as default
};
